<template>
  <div class="studying">
    <!-- 研学 -->
    <Header></Header>
    <Default></Default>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/header";
import Default from "@/components/default";
import Footer from "@/components/footer";
export default {
  name: 'Studying',
  components: { Header, Footer,Default },
  created(){
    sessionStorage.setItem("tabId",3)
  },
}
</script>

<style scoped>
.studying{
  width: 100%;
  height: 100vh;
  background: #171f30;
  overflow: auto;
}
</style>
